export type StoryStepId = 1 | 2 | 3 | 4 | 5 | 6;

export const STORY_STEPS: readonly {
  id: StoryStepId;
  label: string;
  hint: string;
}[] = [
  { id: 1, label: "Pourquoi cette étude ?", hint: "Enjeux" },
  { id: 2, label: "Où sommes-nous ?", hint: "Territoires" },
  // Non-breaking space before the mark: the tile is narrow enough to drop a
  // lone "?" on its own line otherwise.
  { id: 3, label: "Comment l’étude a été réalisée\u00a0?", hint: "Méthode" },
  { id: 4, label: "Quelles sont les tendances ?", hint: "Occupation des sols" },
  { id: 5, label: "Que disent les communautés ?", hint: "Perceptions" },
  { id: 6, label: "Quels services rendent ces écosystèmes ?", hint: "Services" },
];
